// @flow strict
import * as React from 'react';

import styles from './bottom-bar.css';

const BottomBar = (): React.Node => {
  return (
    <div
      className={`nwea-ds-v1-typography-body-copy-medium ${styles.bar}`}
      data-cy="bottom-bar"
    >
      &copy; 2022 NWEA
    </div>
  );
};

export { BottomBar };
